import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n/LanguageContext";

export default function PaymentCancel() {
  const { t } = useT();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-stone-100 to-stone-50 dark:from-stone-950 dark:to-stone-900">
      <div className="max-w-md w-full bg-background rounded-3xl border border-border shadow-xl p-8 text-center" data-testid="payment-cancel-page">
        <div className="h-16 w-16 rounded-3xl bg-stone-100 dark:bg-stone-800 flex items-center justify-center mx-auto mb-4">
          <XCircle className="h-9 w-9 text-stone-500" />
        </div>
        <h1 className="font-display font-bold text-2xl mb-2">{t("payment.cancelTitle")}</h1>
        <p className="text-sm text-stone-500 dark:text-stone-400 mb-5">{t("payment.cancelHelp")}</p>
        <Link to="/">
          <Button className="rounded-full" data-testid="back-home-btn">{t("payment.backToNotes")}</Button>
        </Link>
      </div>
    </div>
  );
}
